import * as React from "react";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { MoneyDisplayHelper } from "../../../../../react-core/Helpers/MoneyDisplayHelper";
import { addDays } from "../../../../../react-core/utils/date";
import TableFilterDropdown from "../../../../../react-core/Html/Components/TableFilterDropdown";
import { MultiplePropFilter } from "./MultiplePropFilter";
import { AssetUnderManagementModel } from "../../../../../Wrap/Models/Models/Business/AssetUnderManagement/AssetUnderManagementModel";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { ServicePropositionMap } from "../../../../Shared/Entities/Maps/ServicePropositionMap";
import CoachMarker from "../../../../Shared/CoachMarkers/CoachMarker";

interface IBusinessManagementHeaderProps extends React.Props<BusinessManagementHeader> {
    data: AssetUnderManagementModel;
    onMultiPropsFilterChange: (selected) => void;
    multiPropsFilter: ServiceProposition[];
}

interface IBusinessManagementHeaderState {
    selectedProposition: ServiceProposition[];
}

export class BusinessManagementHeader extends React.Component<
    IBusinessManagementHeaderProps,
    IBusinessManagementHeaderState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedProposition: [],
        };
    }

    private dropdown;

    public render(): JSX.Element {
        const { data } = this.props;
        let formatMoney = (
            <div className="client-account-value">
                0<span className="decimal-place">.00</span>
            </div>
        );
        const yesterday = addDays(new Date(), -1);
        const date = JsonDateParser.getFormatDateString(yesterday, "dd MM yyyy", true, true);
        if (data) {
            const _formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(
                Math.abs(data?.AUMPerformanceTableData?.TotalAssets),
                CurrencyCode.GBP,
                true,
                2
            );
            const _arry = _formatMoney.split(".");

            formatMoney = (
                <div className="client-account-value">
                    {_arry[0]}
                    <span className="decimal-place">.{_arry[1]}</span>
                </div>
            );
        }
        const showTotal =
            this.state.selectedProposition.length == this.props.multiPropsFilter.length ||
            this.state.selectedProposition.length == 0;
        return (
            <div className="flex-space align-items-end mb-20">
                <div>
                    <div className="row narrow-gutter">
                        <div className="col-auto">
                                <h1 style={{ display: "inline" }}>
                                    <span>{"Business management"}</span>
                                </h1>
                                <CoachMarker coachMarkerKey="business-management-client-filter" />
                                <TableFilterDropdown
                                    cssWrapper="table-default-filter ml-5"
                                    onOpen={(ref) => (this.dropdown = ref)}
                                    labelSrOnly="Business management client filter"
                                >
                                    <MultiplePropFilter
                                        multiPropsFilter={this.props.multiPropsFilter}
                                        onCancel={() => this.dropdown(true)}
                                        onApply={(d) => {
                                            this.dropdown(true);
                                            this.props.onMultiPropsFilterChange(d);
                                            this.setState({ selectedProposition: d });
                                        }}
                                    />
                                </TableFilterDropdown>{" "}
                                Showing{" "}
                                {showTotal
                                    ? "Total"
                                    : this.state.selectedProposition.map((v) => {
                                          return ServicePropositionMap.getString(v) + " ";
                                      })}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-auto">
                            <span className="text-muted text-size-14 mb-0 mr-20">Last updated <b>{date}</b></span>
                        </div>
                    </div>
                </div>
                <div className="text-right">
                    {formatMoney}
                    <div className="text-muted text-size-14">{"Total asset holdings"}</div>
                </div>
            </div>
        );
    }
}
